var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"btn mr-2 ml-2"},[_vm._v(_vm._s(_vm.buttonName))])
}
var staticRenderFns = []

export { render, staticRenderFns }